/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CourseSectionDivisionConnection } from './CourseSectionDivisionConnection';
const CourseSectionDivisionParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['connections', /* #__PURE__ */ codecArray(CourseSectionDivisionConnection)],
]);
export class CourseSectionDivision extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseSectionDivisionParser.decode(input).map(res => new CourseSectionDivision(res));
    }
    static unsafeDecode(input) {
        return CourseSectionDivision.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseSectionDivisionParser.encode(data);
    }
    static schema() {
        return CourseSectionDivisionParser.schema();
    }
}
